import styled from 'styled-components';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@cld/icon';
import { globalTheme } from '@cld/component-theme';
import { typography } from '@cld/typography';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { messages } from '../../../../i18n';

const Link = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${globalTheme.spacing.md};
  ${typography.xxs.regular};

  &, &:visited {
    color: ${globalTheme.palette.contrastHigh};
  }

  ${Icon} {
    color: inherit;
    margin-right: ${globalTheme.spacing.xxs};
  }
`;

export const Info: FC = () => {
  const analytics = useAnalytics();

  return (
    <Link
      className="info"
      href="https://cloudinary.com/documentation/how_to_integrate_cloudinary"
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => analytics('learn more', 'clicked on can\'t find api key to learn about api key in doc')}
    >
      <Icon name="infoOutline" size="sm" />
      <FormattedMessage {...messages['loginModal.main.accountCredentials.cantFindApiKey']} />
    </Link>
  );
};
